import React from 'react';
import * as s from './styles';
const FooterSection = ({ logoSrc }) => {
  return (
    <s.FooterContainer>
      <s.Logo src={logoSrc} alt='Logo' />

      <s.SocialLinks>
        <s.Info>BluePharm, LLC - 2024.</s.Info>

        <s.SocialLink
          href='https://www.instagram.com/bluepharm.cc?igsh=NmxyenN4MWlxMHlm&utm_source=qr'
          target='_blank'
        >
          <s.InstagramIcon />
        </s.SocialLink>
      </s.SocialLinks>
    </s.FooterContainer>
  );
};

export default FooterSection;
